import { RECOMMENDATION_OPTIONS, type ScorecardField } from "./types";

const KEY_RE = /^[a-z][a-z0-9_]{0,39}$/;

export function validateFields(fields: ScorecardField[]): Record<string, string> {
  const errors: Record<string, string> = {};
  if (fields.length < 1 || fields.length > 40) errors._set = "A scorecard type has 1–40 fields.";
  if (fields.filter((f) => f.type === "overall_recommendation").length > 1) errors._set = "Only one overall recommendation per type.";
  const seen = new Set<string>();
  for (const f of fields) {
    const k = f.key;
    if (!KEY_RE.test(k)) errors[k] = "Key must be lowercase letters, digits, underscores; start with a letter.";
    if (seen.has(k)) errors[k] = "Duplicate key.";
    seen.add(k);
    if (!f.label.trim() || f.label.length > 120) errors[k] = "Label is 1–120 characters.";
    if (f.type === "rubric_score") {
      const lv = f.levels ?? [];
      if (lv.length < 2 || lv.length > 7) errors[k] = "A rubric has 2–7 levels.";
      else if (lv.some((l, i) => i > 0 && l.value <= lv[i - 1].value)) errors[k] = "Level values must increase.";
      else if (lv.some((l) => !l.anchor.trim() || l.anchor.length > 200)) errors[k] = "Each level needs an anchor (≤ 200 chars).";
      if (f.evidence === "forbidden") errors[k] = "A rubric cannot be human-only; use single choice for judgment fields.";
    } else if (f.levels) errors[k] = "Only rubric fields have levels.";
    if (f.type === "single_choice") {
      const o = f.options ?? [];
      if (o.length < 2 || o.length > 20 || new Set(o).size !== o.length || o.some((x) => !x.trim() || x.length > 80))
        errors[k] = "Single choice needs 2–20 distinct options (≤ 80 chars).";
    } else if (f.type === "overall_recommendation") {
      if (JSON.stringify(f.options) !== JSON.stringify(RECOMMENDATION_OPTIONS) || f.evidence !== "forbidden" || f.autofill_allowed)
        errors[k] = "Overall recommendation has fixed options and is human-only.";
    } else if (f.options) errors[k] = "Only choice fields have options.";
    if (f.evidence === "forbidden" && f.autofill_allowed) errors[k] = "Human-only fields cannot be auto-filled.";
    if (f.help && f.help.length > 500) errors[k] = "Help text is ≤ 500 characters.";
  }
  return errors;
}
